import { Head } from "@inertiajs/react";
import HelpLayout from "@/components/help/HelpLayout";
import Article from "@/components/help/Article";
import { ARTICLES, getArticle } from "@/help/articles";
import { ROLES, defaultRoleForArticle } from "@/help/roles";

/**
 * Server passes only `slug`. We resolve the article from the registry,
 * and pick the side-nav role from the ?from query param (set by
 * internal links) or fall back to the article's first listed role.
 */
export default function ArticlePage({ slug }) {
  const article = getArticle(slug);
  if (!article) return null;

  const fromRole = readFromParam();
  const roleSlug =
    (fromRole && article.roles.includes(fromRole) && fromRole) ||
    defaultRoleForArticle(slug, article.roles);
  const role = roleSlug ? ROLES[roleSlug] : null;
  const Body = article.component;

  return (
    <HelpLayout
      roleSlug={roleSlug}
      activeArticleSlug={slug}
      breadcrumbs={[
        { label: "Help centre", href: "/help" },
        role && { label: role.label, href: role.helpPath },
        { label: article.title },
      ].filter(Boolean)}
    >
      <Head title={`${article.title} · Help centre`} />
      <Article article={article} role={role}>
        <Body />
      </Article>
    </HelpLayout>
  );
}

function readFromParam() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  return params.get("from");
}
